import type { FiltersContext } from '@openx/components-filters/lib/context/types';
import { FILTER_TYPES } from '@openx/components-filters/lib/FiltersBar/types';
import type { Option } from '@openx/types/options';
import type { TFunction } from 'i18next';
import type { DealPromptFilters } from '../types';

type DealPromptFiltersConfig = FiltersContext<DealPromptFilters>['filtersConfig'];

type TableFiltersConfigParams = {
  t: TFunction;
  accountOptions?: Option[];
};

export const getTableFiltersConfig = ({ t, accountOptions }: TableFiltersConfigParams): DealPromptFiltersConfig => {
  return [
    {
      key: 'account',
      name: t('Data Partner'),
      type: FILTER_TYPES.AUTOCOMPLETE,
      options: accountOptions || [],
      withLoader: true,
      config: {
        selectedPlaceholder: t('[ Select Data Partner ]'),
        emptyPlaceholder: t('[ Select Data Partner ]'),
        dropdownHeight: '220px',
      },
    },
  ];
};
